<template>
  <v-dialog v-model="dialog" max-width="900" transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text">
        <v-row class="pa-0">
          <v-col cols="12">
            <div class="blue--text body-1"> <strong>SKALA PENILAIAN</strong> </div>
            <v-divider />
          </v-col>
          <v-col cols="12">
            <template v-for="(item, id) in skala">
              <v-row :key="item.skor" class="my-n2" no-gutters dense>
                <v-col cols="4">
                  <v-responsive
                    :class="
                      `text-center white--text ${item.color} rounded-circle d-inline-flex align-center justify-center`
                    "
                    height="25"
                    width="25"
                  >
                    {{ max - id }}
                  </v-responsive>
                  <strong class="mx-2">{{ item.title }}</strong>
                </v-col>
                <v-col cols="8">
                  <p class="ml-n10">{{ item.desc }}</p>
                </v-col>
              </v-row>
            </template>
          </v-col>
          <v-col cols="12">
            <b>
              Catatan: Tidak semua perilaku di BARS akan relevan untuk semua individu. Perilaku ini adalah contoh
              kinerja yang membentuk setiap tingkat efektivitas.
            </b>
          </v-col>
          <v-col cols="12">
            <div class="blue--text body-1"> <strong>ADAPUN PENILAIAN TERLAMPIR</strong> </div>
            <v-divider />
          </v-col>
          <v-col cols="12">
            <ul>
              <li v-for="(item, id) in skala" :key="id">
                {{ item.info }}
                <b>maka beri nilai {{ id + min }}</b>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn class="mr-2" color="blue" right dark @click="onClose"> OK </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Panduan Penilaian Wawancara',
    },
    penilaian: {
      type: String,
      default: 'wawancara',
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 5,
    },
  },
  name: 'PopupPanduanEsai',
  data() {
    return {
      dialog: false,
      isChecked: false,
    };
  },
  computed: {
    skala() {
      return [
        {
          skor: '5',
          title: 'Mahir',
          desc: 'Sudah melakukan transfer konsep lintas konteks, praktik efektif, konsisten dan adaptif.',
          info: 'Jika bukti perilaku individu sebagian besar cocok dengan pernyataan kurang memenuhi persyaratan,',
          color: 'success',
        },
        {
          skor: '4',
          title: 'Cakap',
          desc: 'Melakukan perluasan penerapan konsep esensial, praktik efektif, konsisten dan melakukan pengembangan.',
          info:
            'Jika bukti perilaku individu sebagian cocok dengan pernyataan kurang memenuhi persyaratan dan sebagian cocok dengan pernyataan memenuhi persyaratan,',
          color: 'blue',
        },
        {
          skor: '3',
          title: 'Layak',
          desc: 'Penguasaan konsep esensial kompleks, praktik sudah efektif dan konsisten.',
          info: 'Jika bukti perilaku individu sebagian besar cocok dengan pernyataan memenuhi persyaratan,',
          color: 'warning',
        },
        {
          skor: '2',
          title: 'Berkembang',
          desc: 'Penguasaan konsep esensial dasar, Praktik sudah efektif tapi belum konsisten',
          info:
            'Jika bukti perilaku individu sebagian cocok dengan pernyataan memenuhi persyaratan dan sebagian cocok dengan pernyataan melebihi persyaratan,',
          color: 'orange darken-3',
        },
        {
          skor: '1',
          title: 'Lemah ( Weak )',
          desc: 'Menunjukkan perilaku yang tidak efektif dan melewatkan peluang untuk perilaku yang efektif',
          info: 'Jika bukti perilaku individu sebagian besar cocok dengan pernyataan melebihi persyaratan,',
          color: 'red',
        },
      ];
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    onClose() {
      this.dialog = false;
    },
  },
};
</script>
